<template>
  <v-layout fill-height column id="tutorialGuide03">
    <v-main class="page-library page-library-main tutorial-guide-content">
      <AppBar :app="false" title="도서관" hide-back>
        <template #end>
          <v-tooltip attach
                     left
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <v-btn icon plain :ripple="false"
                     class="btn-library-top"
                     v-bind="attrs"
                     @click.prevent>
                <IconSearch />
              </v-btn>
            </template>
            <span class="tooltip-text" id="tooltipLibraryTopSearch">
              콘텐츠를 직접 검색해요.
            </span>
          </v-tooltip>
          <v-tooltip attach
                     bottom
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <v-btn icon plain :ripple="false"
                     class="btn-library-top"
                     v-bind="attrs"
                     @click.prevent>
                <i class="cu-icon-interest on"></i>
              </v-btn>
            </template>
            <span class="tooltip-text text-end" id="tooltipLibraryTopFave">
              찜한 도서관 콘텐츠를<br />모아볼 수 있어요.
            </span>
          </v-tooltip>
        </template>
      </AppBar>
      <v-container fluid>
        <div class="library-category-lists">

          <template v-for="(sbitem, i) in list">
                <div class="library-category-lists-item"
                     :class="`library-category-lists-item-${i}`"
                     :key="`library-category-lists-item-${i}`"
                >
                  <v-tooltip attach
                             top
                             max-width="100vw"
                             class="tooltip-coach"
                             :value="tooltipActive">
                    <template v-slot:activator="{ attrs }">
                      <div class="library-title-block"
                           v-bind="attrs">
                        <h2 class="tit">{{ sbitem.subjectNm }}</h2>
                        <v-btn text :ripple="false"
                               class="btn-allView"
                               @click.prevent
                        >전체보기<i class="ez-dms-arr-right-md ms-2"></i></v-btn>
                      </div>
                    </template>
                    <span v-if="i === 1"
                          class="tooltip-text" id="libraryCategoryListsItem">
                      다양한 주제 별 심리 콘텐츠를 볼 수 있어요!
                    </span>
                  </v-tooltip>
              <Flicking :options="flickingOptions">
                <template v-for="(item, j) in sbitem.items">
                  <div class="library-list-item" :key="`library-list-item-${j}`">
                    <v-img :src="item.imgUrl"
                           aspect-ratio="1"
                           width="120"
                           height="120"
                           class="rounded" />
                    <div class="item-title line-clamp-2">{{ item.title }}</div>
                  </div>
                </template>
              </Flicking>
            </div>
          </template>
        </div>
      </v-container>
      <slot name="bottomMenu" />
    </v-main>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
import IconSearch from "@/components/icons/Search.vue";
export default {
  name: 'TutorialSlide3',
  components: {IconSearch},
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({
    tooltipActive: false,
    list: [
      {
        subjectNm: '명상과 이완',
        items: [
          { title: '이완tip | 불안을 내리는 혈자리-거궐', imgUrl: require('@/assets/images/coach/sample01-01.png') },
          { title: '이완tip | 쉬운 마인드풀니스 명상', imgUrl: require('@/assets/images/coach/sample01-02.png') },
          { title: '이완tip | 자기암시로 불안 관리하기', imgUrl: require('@/assets/images/coach/sample01-03.png') }
        ]
      },
      {
        subjectNm: '행복과 건강',
        items: [
          { title: '[놀심] 지금의 행복을 포기한 사람들의 특징 (김경일 교수)', imgUrl: require('@/assets/images/coach/sample02-01.png') },
          { title: '[놀심] 저절로 체중이 줄어드는 생각 세팅하기 (비만치료 전문가 유은정 원장)', imgUrl: require('@/assets/images/coach/sample02-02.png') },
          { title: '[놀심] 3초만에 매력을 주는 목소리 내는 방법 (임대혁 대표)', imgUrl: require('@/assets/images/coach/sample02-03.png') }
        ]
      },
      {
        subjectNm: '나 그리고 너',
        items: [
          { title: '[놀심]나이 들수록 혼자서 시간을 보내야 하는 이유 (김민식 PD)', imgUrl: require('@/assets/images/coach/sample03-01.png') },
          { title: '[놀심] 혼자인 것 처럼 외로울 때, 나의 평생 친구를 찾는 대화법 (김경일 교수)', imgUrl: require('@/assets/images/coach/sample03-02.png') },
          { title: '[놀심] 남자가 반했을 숨기지 못하는 호감신호 (김현진 대표)', imgUrl: require('@/assets/images/coach/sample03-03.png') }
        ]
      }
    ],
    flickingOptions: {
      disable: true,
      align: 'prev',
      // renderOnlyVisible: true,
      moveType: 'freeScroll',
      circularFallback: "bound",
      circular: false,
      bound: true
    }
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<style lang="scss" scoped>
.tooltip-coach {
  #tooltipLibraryTopSearch {
    top: 5px;
    left: 20px;
    &:after {
      transform: scaleX(-1) rotate(40deg);
      right: 0;
      top: -25px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #tooltipLibraryTopFave {
    top: 10px;
    left: -40px;
    &:after {
      transform: scale(-1);
      right: -55px;
      top: -20px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
  #libraryCategoryListsItem {
    left: 10px;
    top: -60px;
    &:after {
      left: -50px;
      top: 5px;
      width: 48px;
      height: 29px;
      background-image: var(--coach-mark-arrow-03);
    }
  }
}
.tutorial-guide-content::v-deep {
  flex: 1 1 auto;
  overflow: hidden;
  .content-header {
    position: relative;
    z-index: 8;
    .v-toolbar__extension,
    .v-toolbar__content {
      &::after {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .75);
        z-index: 7;
      }
    }
  }
  .btn-library-top {
    z-index: 8;
    background-color: #fff;
  }
  .container {
    box-sizing: border-box;
  }
  .library-category-lists-item-1 {
    position: relative;
    z-index: 8;
    padding: 0 20px 0 10px;
    margin: 0 -10px;
    border-radius: 15px;
    background-color: #fff;
  }
}
</style>
